/* eslint-disable camelcase */
/* eslint-disable dot-notation */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-associated-control */

// @mui material components
import Card from "@mui/material/Card";
// import TextField from "@mui/material/TextField";
import React, { useState, useEffect } from "react";
import "react-dropdown/style.css";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// import MenuItem from "@mui/material/MenuItem";
// import FormControl from '@mui/material/FormControl';
// import Select from "@mui/material/Select";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AlertDialog from "./dialog_success";
import DeleteSetting from "./delete_setting";

function AddCustomer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [users, setUsers] = useState([""]);
  const [name, setName] = useState();
  const [code, setCode] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [vat_name, setVatname] = useState();
  const [user, setUser] = useState("");
  const getCustomers = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/users");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setUsers(data["users"]);
  };
  useEffect(() => {
    getCustomers();
  }, []);
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">Add Customer</SuiTypography>
            </SuiBox>
            <div style={{ width: "400px", margin: "20px" }}>
              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Name
                </label>
                <input
                  required
                  id="value"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Code
                </label>
                <input
                  required
                  id="value"
                  onChange={(e) => setCode(e.target.value)}
                  value={code}
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Phone Number
                </label>
                <input
                  required
                  id="value"
                  onChange={(e) => setPhone(e.target.value)}
                  value={phone}
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Address
                </label>
                <input
                  required
                  id="value"
                  onChange={(e) => setAddress(e.target.value)}
                  value={address}
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
              </div>
              <div className="form-group  col-md-12 ">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Vat Name
                </label>
                <input
                  required
                  id="value"
                  onChange={(e) => setVatname(e.target.value)}
                  value={vat_name}
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                />
              </div>
              <div className="form-group  col-md-12">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px", color: "black" }}
                >
                  Choose User
                </label>
                <select
                  id="shop"
                  className="form-control"
                  style={{ height: "40px" }}
                  onChange={(e) => setUser(e.target.value)}
                >
                  {users.map((user1) => (
                    <option value={user1.id}>{user1.name}</option>
                  ))}
                </select>
              </div>

              <AlertDialog
                name1={name}
                address1={address}
                phone1={phone}
                code1={code}
                vat1={vat_name}
                user_id1={user}
              />
            </div>
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddCustomer;
